export enum ScreenSplitMode {
  DISABLED = 'disabled',
  AUTO_SCREEN_SPLIT = 'auto_screen_split',
}
